import React from 'react'
import styled from 'styled-components'
import { Text, Box, Flex } from 'uikit'
import { useTranslation } from 'contexts/Localization'

const ModelBg = styled(Box)`
  ${({ theme }) => theme.mediaQueries.lg} {
    background-image: url('/images/home/quality-bg.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
  }
`

const PurpleTitle = styled(Text)`
  font-size: 18px;

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 20px;
  }
`

const Title = styled(Text)`
  font-size: 25px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 30px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 35px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 40px;
  }
`

const Detail = styled(Text)`
  font-size: 14px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    font-size: 16px;
  }
`

const Model = styled.img`
  width: 250px;

  ${({ theme }) => theme.mediaQueries['2sm']} {
    width: 350px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    width: 400px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 445px;
  }
`

const data = [
  {
    icon: 'check-circle',
    label: 'Endorsement',
    desc: 'We delivered, and continue to deliver, proven and known use cases',
  },
  {
    icon: 'arrow-up-circle',
    label: 'Improvement',
    desc: 'We are creating beneficial advancements for the user experience',
  },
  {
    icon: 'diamond',
    label: 'Transparency',
    desc: 'We are constantly updating and providing information to our users',
  },
]

const Quality: React.FC = () => {
  const { t } = useTranslation()

  return (
    <ModelBg mt={['62px', null, null, null, '45px']} px={['35px', null, '57px']}>
      <PurpleTitle color="primary" fontWeight="600" textAlign="center">
        {t('Our Vision')}
      </PurpleTitle>
      <Title fontWeight="600" textAlign="center">
        {t('Quality is the Focus')}
      </Title>
      <Detail fontWeight="300" textAlign="center" color="textSecondary" maxWidth="660px" mx="auto" mt="20px">
        {t(
          'Dark Matter DeFi strives to be transparent at every step, eliminating any gaps in communication between our Core Team and the Valued Community.',
        )}
      </Detail>
      <Flex
        mt={['28px', null, '56px', null, null, '68px']}
        justifyContent="space-between"
        mx="auto"
        alignItems="center"
        maxWidth="860px"
        flexDirection={['column', null, null, null, null, 'row']}
      >
        <Model src="/images/home/quality-model.png" alt="quality-model" />
        <Box mt={['40px', null, '70px', null, null, '0']}>
          {data.map((item, index) => (
            <Flex key={index} mt={index === 0 ? '0px' : '50px'} alignItems="start">
              <img src={`/images/home/${item.icon}.svg`} alt="check-circle" />
              <Box ml="36px" maxWidth="272px">
                <Text fontSize="18px" color="primary" fontWeight="600" lineHeight="22px">
                  {t(item.label)}
                </Text>
                <Text mt="10px" fontSize="16px" fontWeight="300" color="textSecondary">
                  {t(item.desc)}
                </Text>
              </Box>
            </Flex>
          ))}
        </Box>
      </Flex>
    </ModelBg>
  )
}

export default Quality
